import "./style.css";
import Orchestrator from "./ThreeJS/Orchestrator.js";

const orchestrator = new Orchestrator(document.querySelector("canvas.webgl"));
